export const inputClass =
  "mt-1.5 w-full rounded-lg border border-line bg-surface px-3 py-2 text-[15px] outline-none transition-colors duration-150 placeholder:text-muted/60 focus:border-ink";

export const labelClass = "text-sm font-medium";
